// Call plugin.
import * as actionTypes from '../actionTypes'

function trackManagerHelper (type, trackId, payload = {}, meta = {}) {
  return {
    type,
    payload: {
      ...payload,
      trackId
    },
    meta
  }
}

export function trackAdded (trackId, params) {
  return trackManagerHelper(actionTypes.TRACK_ADDED, trackId, params)
}

export function trackRemoved (trackId, params) {
  return trackManagerHelper(actionTypes.TRACK_REMOVED, trackId, params)
}

function trackHelper (type, payload = {}, meta = {}) {
  const action = {
    type,
    payload,
    meta
  }

  if (payload.error) {
    action.error = true
  }

  return action
}

export function muteTracks (trackIds) {
  return trackHelper(actionTypes.MUTE_TRACKS, trackIds)
}

export function muteTracksFinish (trackIds) {
  return trackHelper(actionTypes.MUTE_TRACKS_FINISH, { trackIds: trackIds })
}

export function unmuteTracks (trackIds) {
  return trackHelper(actionTypes.UNMUTE_TRACKS, trackIds)
}

export function unmuteTracksFinish (trackIds) {
  return trackHelper(actionTypes.UNMUTE_TRACKS_FINISH, { trackIds: trackIds })
}

export function trackSourceMuted (trackIds, params) {
  return trackHelper(actionTypes.TRACK_SOURCE_MUTED, { trackIds: trackIds, ...params })
}

export function trackSourceUnmuted (trackIds, params) {
  return trackHelper(actionTypes.TRACK_SOURCE_UNMUTED, { trackIds: trackIds, ...params })
}

export function renderTracks (trackIds, params) {
  return trackHelper(actionTypes.RENDER_TRACKS, {
    trackIds,
    ...params
  })
}

export function renderTracksFinish (trackIds, params) {
  return trackHelper(actionTypes.RENDER_TRACKS_FINISH, {
    trackIds,
    ...params
  })
}

export function removeTracks (trackIds, params) {
  return trackHelper(actionTypes.REMOVE_TRACKS, {
    trackIds,
    ...params
  })
}

export function removeTracksFinish (trackIds, params) {
  return trackHelper(actionTypes.REMOVE_TRACKS_FINISH, {
    trackIds,
    ...params
  })
}
